import styled from 'styled-components';
import colors from '../../assets/styles/colors';

export const InputCheckboxContainer = styled.div`
  box-shadow: 0px 8px 25px ${colors.shadow};
  border-radius: 8px;
  padding: 17px;
  align-items: center;
  display: flex;
`;

export const InputCheckboxField = styled.div`
  width: 25px;
  height: 25px;
  border-radius: 4px;
  border: 1.5px solid ${colors.textHyperlink};
  background: ${prop => prop.checked ? colors.textHyperlink : colors.white};
  margin-right: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const InputCheckboxLabel = styled.h6`
  color: ${colors.textPrimary};
  font-weight: 600;
  font-size: 17px;
  line-height: 21px;
`;
